import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CanDeactivateGuard } from 'app/core/guards/can-deactivate-guard';
import { canActivateScootaverses } from 'app/core/guards/scootaverse-guard.service';

import { RegistrationPageComponent } from '../social-events/pages/registration-page/registration-page.component';

import { CreateRoomPageComponent } from './pages/create-room/create-room-page.component';
import { EditRoomPageComponent } from './pages/edit-room/edit-room-page.component';
import { ScootaverseBadgingComponent } from './scootaverse-badging/scootaverse-badging.component';
import { EntryFlowDetailsComponent } from './scootaverse-entry-flows/create-entry-flow/entry-flow-details.component';
import { EntryFlowsComponent } from './scootaverse-entry-flows/entry-flows.component';
import { ScootaversePageComponent } from './scootaverse-page/scootaverse-page.component';
import { RoomAdvancedSettingsComponent } from './scootaverse-rooms/room-settings/advanced-settings/room-advanced-settings.component';
import { RoomSettingsComponent } from './scootaverse-rooms/room-settings/room-settings.component';
import { ScootaverseRoomsComponent } from './scootaverse-rooms/scootaverse-rooms.component';
import { ScootaverseSettingsPageComponent } from './scootaverse-settings-page/scootaverse-settings-page.component';
import { ScootaversesComponent } from './scootaverses/scootaverses.component';
import { EventCountdownPageComponent } from '../social-events/pages/event-countdown/event-countdown-page.component';

const routes: Routes = [
  {
    path: 'home',
    canActivate: [canActivateScootaverses],
    component: ScootaversePageComponent,
    children: [
      {
        path: 'scootaverses',
        component: ScootaversesComponent,
      },
      {
        path: 'scootaverses/activate-survey/:room-id',
        data: { show: true },
        component: ScootaversesComponent,
      },
      {
        path: 'scootaverses/guest/activate-survey/:room-id',
        data: { show: true },
        component: ScootaversesComponent,
      },
      {
        path: 'scootaverses/:id/rooms',
        component: ScootaverseRoomsComponent,
      },
      {
        path: 'scootaverses/:id/room/:room-id/settings',
        component: RoomSettingsComponent,
      },
      {
        path: 'scootaverses/:id/room/:room-id/advanced-settings',
        component: RoomAdvancedSettingsComponent,
      },
      {
        path: 'scootaverses/:id/settings',
        component: ScootaverseSettingsPageComponent,
      },
      {
        path: 'scootaverses/:id/smart-badging',
        component: ScootaverseBadgingComponent,
      },
      {
        path: 'scootaverses/:id/create-room',
        component: CreateRoomPageComponent,
        canDeactivate: [CanDeactivateGuard],
      },

      // old edit flow redirect
      {
        path: 'scootaverses/:id/edit-room/:room-id',
        component: CreateRoomPageComponent,
        canDeactivate: [CanDeactivateGuard],
      },

      //new edit flow redirect
      {
        path: 'scootaverses/:id/room-editor/:room-id',
        component: EditRoomPageComponent,
      },

      {
        path: 'scootaverses/:id/room-editor/:room-id/step/:step-id',
        component: CreateRoomPageComponent,
        canDeactivate: [CanDeactivateGuard],
      },

      {
        path: 'scootaverses/:id/entry-flows',
        component: EntryFlowsComponent,
      },
      {
        path: 'scootaverses/:id/entry-flows/create-flow',
        component: EntryFlowDetailsComponent,
      },
      {
        path: 'scootaverses/:id/entry-flows/edit-flow/:flow-id',
        component: EntryFlowDetailsComponent,
      },
    ],
  },
  {
    path: 'web/events/:companyName/:customName/registration',
    component: RegistrationPageComponent,
  },
  {
    path: 'events/:companyName/:customName',
    component: RegistrationPageComponent,
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home/scootaverses',
  },
  {
    path: 'home',
    pathMatch: 'full',
    redirectTo: 'home/scootaverses',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ScootaverseRoutingModule {}
